import template from './rating_distribution_help.html'
import * as Utils from '../../../lib/savanna_utils.js'

class RatingsDistributionHelpViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog;
    }

    close()
    {
        this.dialog.close();
    }
}

class RatingsDistributionHelpPage
{
    constructor(bindings)
    {
        this.viewModel = new RatingsDistributionHelpViewModel(this);
        this.bindings = bindings;
    }

    init()
    {
        Utils.refresh_data_visible_roles();
    }
}

export default {
    name: 'RatingsDistributionHelp',
    dialog_class: RatingsDistributionHelpPage,
    template: template,
    template_filename: 'translation/dialogs/rating_distribution_help',
    provider: 'ps',
};
